export class NonCommissionType {

  static readonly PAID_DIRECT = 'Commission Paid Direct';
  static readonly EVENT_CANCELLED = 'Event Cancelled';

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/non-commission-type.ts